export const config = {
  chatApiUrl: import.meta.env.VITE_CHAT_API_URL ?? '',
};
